import React, { useState } from "react";
import CommonButton from "../../../CommonComponents/CommonButton";
import {
  Grid,
  Typography,
  Card,
  TextareaAutosize,
  Button,
  Box,
} from "@mui/material";
import style from "./RecommendationYesNoPopup.module.css";
import CommonModal from "../../../CommonComponents/Modal/CommonModal";
import CheckboxLabels from "../../../CommonComponents/CheckboxLabel/CheckboxLabels";
import { openCaseRecommendationList } from "../../../constants/utils";
import {
  recommendation,
  submitFinal,
  policeComplaintPostApi,
} from "../../../Services/caseManagement.service";
import { useDispatch, useSelector } from "react-redux";
import useToaster from "../../../customHook/useToaster";
import DeEmpanelHospital from "../../../CommonComponents/DeEmpanelHospital";
import { isLoadingStateReducer } from "../../../Redux/Slice/loginSlice";
import { analyticsEvent } from "../../../Utils/helper";
import { useCallback } from "react";
import RegulatoryDetails from "../../../CommonComponents/TableGridView/RegulatoryDetails";
import styled from "styled-components";
import PromptModal from "../../../CommonComponents/PromptModal/PromptModal";
const ThemedTextareaAutosize = styled(TextareaAutosize)(
  ({ theme }) => `
  resize: none;
width: 100%;
padding: 0.6rem;
borderRadius: 4px;
border: 1px solid #E8E8E8;
fontFamily: inter;
fontSize: 1.4rem;
lineHeight: 1.5;`
);

const Approval = ({
  isReassign = false,
  onReassignClick = () => {},
  onClick = () => {},
  buttonOneLabel = "No",
  buttonTwoLabel = "Yes",
  onlyButton = false,
  isRemark = false,
  isRemarkRequired = false,
  remarkLabel = "Remark",
  remarkPlaceholder = "Enter Remark",
  remarkVal = "",
  onChange = () => {},
  onSubmit = () => {},
  isSubmit = false,
  message = "Are you sure you want to approve ?",
  displaySecondTab = () => {},
}) => {
  const caseId = useSelector((state) => state?.CaseDescriptionSlice?.caseId);
  const [showModal, setShowModal] = useState("");
  const [modalType, setModalType] = useState("");
  const [checkedItem, setCheckedItem] = useState([]);
  const [approvalModalRemarkValue, setApprovalModalRemarkValue] = useState("");
  const currentRole = useSelector(
    (state) => state?.loginSlice?.userData?.currentRoleName
  );
  const { username } = useSelector((state) => state?.loginSlice?.userData);
  const { showToast } = useToaster();
  const dispatch = useDispatch();

  const handleInputChange = (e) => {
    setApprovalModalRemarkValue(e.target.value);
    onChange(e);
  };

  const handleNoClick = () => {
    if (isSubmit) {
      submitFinal(caseId)
        .then((data) => {
          showToast(data?.message, "success", true);
          // if (localStorage.getItem("redirectLinkIsVisted") !== username) {
          //   setShowModal(true);
          //   setModalType("Re-direct"); // temp-code
          // } else {
          setShowModal(false);
          onClick(false);
          // }
          displaySecondTab();
        })
        .catch((err) => {
          if (err?.response?.status === 504)
            return showToast("Taking longer than usual.", "error", true);
          showToast(err?.response?.data?.message, "error", true);
        });
      return;
    }
    onClick(false);
    setShowModal(false);
  };

  const handleYesClick = () => {
    onClick(true);
    if (isSubmit) {
      setShowModal(true);
      setModalType("Regulatory Details");
    }
  };
  const handleNoClickModal = () => {
    setShowModal(false);
  };

  const getRecommendedData = () => {
    let b = [];
    checkedItem.forEach((item) => {
      if (item?.checked) {
        b.push(item?.label);
      }
    });
    return b.join(",");
  };

  const submitFinalApiCall = (action, params) => {
    submitFinal(caseId)
      .then((data) => {
        //Google Analytics Event to Track Case Final Submit
        analyticsEvent(
          "Submit Final",
          "Submit Final Success",
          "Submit Final Success"
        );
        if (data?.success) {
          action(...params)
            ?.then((response) => {
              if (response?.success) {
                dispatch(isLoadingStateReducer(false));
                showToast(response?.message, "success", true);
                // if (localStorage.getItem("redirectLinkIsVisted") !== username) {
                //   setModalType("Re-direct"); // temp-code
                // } else {
                onClick(false);
                setShowModal(false);
                // }
                displaySecondTab();
              }
            })
            ?.catch((err) => {
              dispatch(isLoadingStateReducer(false));
              if (err?.response?.status === 504)
                return showToast("Taking longer than usual.", "error", true);
              showToast(err?.response?.data?.message, "error", true);
            });
          onClick(false);
          setShowModal(false);
        }
      })
      .catch((err) => {
        dispatch(isLoadingStateReducer(false));
        showToast(err?.response?.data?.message, "error", true);
      });
  };

  const policeComplaint = () => {
    if (!approvalModalRemarkValue)
      return showToast("Please provide remark.", "warning", true);
    dispatch(isLoadingStateReducer(true));
    submitFinalApiCall(policeComplaintPostApi, [
      { caseId, remark: approvalModalRemarkValue },
    ]);
    displaySecondTab();
  };

  const handleYesClickModal = () => {
    let isPoliceChecked = checkedItem?.find(
      (obj) => obj?.label === "Police Complaint" && obj?.checked
    );
    if (isPoliceChecked) return setModalType("Action Modal");

    let isHospitalGarageChecked = checkedItem?.find(
      (obj) =>
        (obj?.label === "De-Empanel Hospital" ||
          obj?.label === "Negative Garage") &&
        obj?.checked
    );
    if (isHospitalGarageChecked) return setModalType("De-empanel");
  };

  const onModalClose = () => {
    if (modalType === "Action Modal" || modalType === "De-empanel") {
      setModalType("Recommendations");
      return;
    }
    setShowModal(false);
  };

  const actionComponent = useCallback(() => {
    return (
      <>
        <Grid container>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            sx={{
              paddingBottom: "10px",
              paddingTop: "10px",
            }}
          >
            <Typography
              sx={{
                fontSize: "1.6rem",
                fontWeight: "500",
                color: "#505050",
                textAlign: "center",
              }}
            >
              Are you sure you want to submit ?
            </Typography>
          </Grid>
        </Grid>
        <div style={{ marginTop: "1.3rem" }}>
          <Typography
            sx={{
              marginBottom: "1.2rem",
              color: "#7C7C7C",
              fontSize: "1.4rem",
              padding: "-0.1rem -0.1rem",
            }}
          >
            Remarks
            <span style={{ color: "rgb(231, 55, 59)" }}> *</span>
          </Typography>

          <ThemedTextareaAutosize
            disabled={false}
            minRows={4}
            placeholder={remarkPlaceholder}
            size="lg"
            value={approvalModalRemarkValue}
            onChange={handleInputChange}
          />

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "1.7rem",
              marginBottom: "1.7rem",
            }}
          >
            <Button
              variant="contained"
              sx={{
                ":hover": {
                  bgcolor: "#e85055",
                  color: "white",
                },
                width: "max-content",
                textTransform: "none",
                display: "flex",
                backgroundColor: "#e85055",
                fontSize: "1.2rem",
                padding: "0.8rem 2.7rem",
                boxShadow: "4px 4px 3px rgba(0, 0, 0, 0.25)",
                color: "white",
              }}
              onClick={policeComplaint}
            >
              Submit
            </Button>
          </div>
        </div>
      </>
    );
  }, [approvalModalRemarkValue]);

  const recommendationComponent = useCallback(() => {
    return (
      <>
        <Typography
          sx={{
            marginBottom: "1.5rem",
            fontSize: "1.6rem",
            fontWeight: "500",
            color: "#505050",
          }}
        >
          Recommendations
        </Typography>
        <CheckboxLabels
          labels={
            currentRole?.toLowerCase() === "nh"
              ? openCaseRecommendationList?.filter(
                  (label) => label !== "Negative Garage"
                )
              : openCaseRecommendationList
          }
          onChange={(value) => {
            setCheckedItem(value);
          }}
        />
        <Box sx={{ marginTop: "1rem" }}>
          <div
            className={style["common_button"]}
            style={{
              justifyContent: "flex-start",
            }}
          >
            <div className={style["no_button"]}>
              <CommonButton
                label={"Cancel"}
                backgroundColor
                onClick={handleNoClickModal}
                fitContent={true}
              />
            </div>
            <div className={style["yes_button"]}>
              <CommonButton
                label={"Proceed"}
                filledButton
                backgroundColor
                onClick={handleYesClickModal}
                fitContent={true}
              />
            </div>
          </div>
        </Box>
      </>
    );
  }, [checkedItem]);

  const modalFactory = useCallback(
    (x) => {
      let component = null;
      switch (x) {
        case "Action Modal":
          component = actionComponent();
          break;
        case "Regulatory Details":
          component = (
            <RegulatoryDetails
              sx={{ padding: "20px 15px 0 15px" }}
              data={{}}
              onSubmit={() => setModalType("Recommendations")}
            />
          );
          break;
        case "Recommendations":
          component = recommendationComponent();
          break;
        case "De-empanel":
          component = (
            <DeEmpanelHospital
              type={checkedItem?.find((obj) => obj?.checked)?.label}
              submitFinalApiCall={submitFinalApiCall}
            />
          );
          break;
        // case "Re-direct":
        //   component = (
        //     <PromptModal
        //       title="Please complete a short mandatory survey."
        //       showButton={false}
        //       isRemark={false}
        //       onlyButton
        //       okayButton
        //       handleOkayClick={() => {
        //         localStorage.setItem("redirectLinkIsVisted", username);
        //         window.location.href = "https://www.surveymonkey.com/r/FDHXQL9";
        //       }}
        //     />
        //   );
        //   break;
        default:
          return "Failed to load";
      }
      return component;
    },
    [approvalModalRemarkValue, checkedItem]
  );

  const renderModalComponent = useCallback(() => {
    return modalFactory(modalType);
  }, [modalFactory, modalType]);

  return (
    <div style={{ width: "100%" }}>
      {!onlyButton && (
        <Grid container>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            sx={{
              paddingBottom: "10px",
              paddingTop: "10px",
            }}
          >
            <Typography
              sx={{
                fontSize: "1.6rem",
                fontWeight: "500",
                color: "#505050",
                textAlign: "center",
              }}
            >
              {message}
            </Typography>
          </Grid>
        </Grid>
      )}
      {isReassign ? (
        <>
          <div className={style["reassign_button"]}>
            <CommonButton
              sx={{ borderRadius: "1rem" }}
              label={"Assign to same vendor"}
              filledButton
              backgroundColor
              onClick={() => onReassignClick("same")}
              fitContent={onlyButton}
            />
          </div>
          <div className={style["reassign_button"]}>
            <CommonButton
              sx={{ borderRadius: "1rem" }}
              label={"Assign to different vendor"}
              filledButton
              backgroundColor
              onClick={() => onReassignClick("different")}
              fitContent={onlyButton}
            />
          </div>
          <div className={style["reassign_button"]}>
            <CommonButton
              sx={{ borderRadius: "1rem" }}
              label={"Manually assign case"}
              filledButton
              backgroundColor
              onClick={() => onReassignClick("manual")}
              fitContent={onlyButton}
            />
          </div>
        </>
      ) : (
        <div
          className={style["common_button"]}
          style={{
            justifyContent: onlyButton ? "flex-start" : "center",
          }}
        >
          <div className={style["no_button"]}>
            <CommonButton
              label={buttonOneLabel}
              backgroundColor
              onClick={handleNoClick}
              fitContent={onlyButton}
            />
          </div>
          <div className={style["yes_button"]}>
            <CommonButton
              label={buttonTwoLabel}
              filledButton
              backgroundColor
              onClick={handleYesClick}
              fitContent={onlyButton}
            />
          </div>
        </div>
      )}
      {isRemark && (
        <div style={{ marginTop: "1.3rem" }}>
          <Typography
            sx={{
              marginBottom: "1.2rem",
              color: "#7C7C7C",
              fontSize: "1.4rem",
              padding: "-0.1rem -0.1rem",
            }}
          >
            {remarkLabel}
            {isRemarkRequired && (
              <span style={{ color: "rgb(231, 55, 59)" }}> *</span>
            )}
          </Typography>

          <ThemedTextareaAutosize
            disabled={false}
            minRows={4}
            placeholder={remarkPlaceholder}
            size="lg"
            value={approvalModalRemarkValue}
            onChange={handleInputChange}
          />

          {isRemark && approvalModalRemarkValue?.trim()?.length > 0 && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "1.7rem",
                marginBottom: "1.7rem",
              }}
            >
              <Button
                variant="contained"
                sx={{
                  ":hover": {
                    bgcolor: "#e85055",
                    color: "white",
                  },
                  width: "max-content",
                  textTransform: "none",
                  display: "flex",
                  backgroundColor: "#e85055",
                  fontSize: "1.2rem",
                  padding: "0.8rem 2.7rem",
                  boxShadow: "4px 4px 3px rgba(0, 0, 0, 0.25)",
                  color: "white",
                }}
                onClick={() => onSubmit(approvalModalRemarkValue)}
              >
                Submit
              </Button>
            </div>
          )}
        </div>
      )}
      <CommonModal
        label={modalType === "Regulatory Details" ? "Regulatory Details" : ""}
        open={showModal}
        onClose={onModalClose}
        showCrossIcon={modalType !== "Re-direct"}
        hideBackdrop={modalType === "Re-direct"}
        height={modalType === "De-empanel" ? "90%" : "auto"}
        width={
          modalType === "De-empanel"
            ? "90%"
            : modalType === "Regulatory Details"
            ? "70%"
            : "44rem"
        }
      >
        {renderModalComponent()}
      </CommonModal>
    </div>
  );
};

export default Approval;
